import { action } from 'mobx';

import * as service from '@crochik/pi-react/services/DataService';

import API from './API';
import { CalendarProps } from '@crochik/pi-react/ui/material/Calendar2';
// import { Default } from '@crochik/pi-react/context';
// import { AppointmentFormState } from '../AppointmentForm';

class DataService extends service.DataService {
    selectMapping: { [entity: string]: ((query?: service.Query) => Promise<any>) } = {};
    slots?: CalendarProps;

    constructor() {
        super();

        this.selectMapping = {
            Slots: async () => await this.getSlots()
        };

        // simulate no slots available.
        // this.slots = {
        //     days: [],
        //     collapseDays: true
        // };
    }

    async getSlots() {
        if (!this.slots) {
            this.slots = await API().slots;
        }
        return this.slots;
    }

    @action
    async select(entity: string, query?: service.Query): Promise<any> {
        let getter = this.selectMapping[entity];
        if (!getter) {
            throw new Error(`${entity}: data service not implemented`);
        }

        let json = await getter(query);

        return json;
    }
}

export default function register() {
    service.register(new DataService());
}


// WEBPACK FOOTER //
// ./src/app/services/Data.ts